import React, { Component } from "react";
import { Platform, StyleSheet, TouchableHighlight, View } from "react-native";
import Text from "../components_v2/TextFont";
// import * as FileSystem from "expo-file-system";
import { connect } from "react-redux";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faPlus,
  faChevronDown,
  faEdit,
  faChevronUp,
  faEllipsisV,
} from "../../assets/consts/faCharCodes";
import { translate } from "../../src/locales/translate";
import { Box, HStack, IconButton } from "native-base";
import Theme from "../argon-ui/Theme";
import { ArButton } from "../argon-ui";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";
import { getDir } from "../util";
// import Theme from "../argon-ui/Theme";
class AreaListItem extends Component {
  constructor(props) {
    super(props);
    this._MenuRef = undefined;
    this.state = {
      isSubAreasOpened: false,
      menuVisible: false,
    };
  }

  async componentDidMount() {
    this.getDependenceAsync();
  }
  getDependenceAsync = async () => {
    const currentServer = await this.props.appReducer?.currentServer;

    if (!this.state.serverUrl || !this.props.accessToken) {
      try {
        this.setState({
          serverUrl:
            this.props.appReducer?.serverUrl ||
            currentServer?.publicAddress ||
            "",
          accessToken: currentServer?.accessToken || "",
        });
      } catch (err) {
        console.log(err);
      }
    }
  };
  toggleSubAreas = () => {
    this.setState({ isSubAreasOpened: !this.state.isSubAreasOpened });
  };

  handleOnAddPress = () => {
    if (this.props.navigator) {
      this.props.navigator.navigate("AreaForm", {
        parentAreaId: this.props.model.areaId,
        parentAreaUId: this.props.model.areaUId,
        parentAreaName: this.props.model.areaName,
      });
    }
  };

  NavigateEditForm = () => {
    if (this.props.navigator) {
      this.props.navigator.navigate("AreaForm", { ...this.props.model });
    }
  };
  hideMenu = () => this.setState({ menuVisible: false });
  showMenu = () => this.setState({ menuVisible: true });
  render() {
    const model = this.props.model || {};
    var subAreas = [];
    if (model.subAreas && model.subAreas.length) {
      let { allAreas } = this.props;
      for (var k in allAreas) {
        const area = allAreas[k];
        const _areaId = area.areaId || area.areaUId;
        if (model.subAreas.indexOf(_areaId) >= 0) {
          subAreas.push(area);
        }
      }
      if (subAreas.length > 0) {
        model.subAreas = subAreas;
      }
      // for (var k in allAreas) {
      //   if (model.subAreas.indexOf(allAreas[k].areaId) >= 0) {
      //     subAreas.push(allAreas[k]);
      //   }
      // }
      // if (subAreas.length > 0) {
      //   model.subAreas = subAreas;
      // }
    }
    // let imgSourceResolver = Actions.resolveImageSource(
    //   model.areaId || model.areaUId,
    //   model.imageSource,
    //   this.state.serverUrl,
    //   this.state.accessToken
    // );
    // let imgWidth = 107,
    //   imgHeight = 60,
    //   bgColor = "#FFF",
    //   pdn = 10;
    // switch (this.props.variation) {
    //   case "sm":
    //     imgHeight = 30;
    //     imgWidth = 53;
    //     bgColor = "#ddd";
    //     pdn = 3;
    //     break;
    //   case "md":
    //     imgHeight = 45;
    //     imgWidth = 80;
    //     bgColor = "#eee";
    //     pdn = 5;
    //     break;
    //   case "lg":
    //   default:
    //     imgHeight = 60;
    //     imgWidth = 107;
    //     bgColor = "#fff";
    //     pdn = 10;
    //     break;
    // }
    return (
      <Box
        p="3"
        mt={this.props.variation ? "6" : "3"}
        style={[
          style.wrapper,
          {
            direction: getDir(),
            backgroundColor: this.props.variation
              ? Theme.COLORS.SECONDARY
              : Theme.COLORS.WHITE,
          },
        ]}
      >
        {/* === Area === */}
        <HStack space="3" pb="0" alignItems="flex-start">
          {/* === Menu Icon === */}
          {(model.accessLevel === "Admin" ||
            model.accessLevel === "Support") && (
            <View >
              <IconButton
                colorScheme="muted"
                variant="ghost"
                onPress={() => {
                  this.showMenu();
                }}
                icon={
                  <FontAwesomeIcon
                    icon={faEllipsisV}
                    size={16}
                    color={Theme.COLORS.MUTED}
                  />
                }
              />
              {this.state.menuVisible && (
                <Menu
                  visible={this.state.menuVisible}
                  onRequestClose={this.hideMenu}
                >
                  {/* === Devices === */}
                  <MenuItem
                    onPress={() => {
                      this.hideMenu();
                      let { areaId, areaUId } = this.props.model;
                      this.props.navigator.navigate("Devices", {
                        areaId,
                        areaUId,
                      });
                    }}
                  >
                    <RenderMenuItem>
                      {translate("area.devices")}{" "}
                      {this.props.model.devices != undefined &&
                        this.props.model.devices.length > 0 &&
                        `(${this.props.model.devices.length})`}
                    </RenderMenuItem>
                  </MenuItem>
                  {/* === Area Logs == */}
                  <MenuItem
                    onPress={() => {
                      this.hideMenu();
                      // let { areaId, areaUId } = navigation.state.params;
                      let { areaId, areaUId } = this.props.model;
                      // var _areaId = areaId;
                      // if (typeof areaId == "number") {
                      //   areaId = areaId;
                      // } else if (typeof areaUId == "string") {
                      //   areaId = areaUId;
                      // }
                      this.props.navigator.navigate("AreaLogs", {
                        areaId,
                        areaUId,
                      });
                    }}
                  >
                    <RenderMenuItem>{translate("area.logs")}</RenderMenuItem>
                  </MenuItem>
                  {/* === DefinedStates === */}
                  <MenuItem
                    onPress={() => {
                      this.hideMenu();
                      let { areaId, areaName, areaUId, uId } = this.props.model;
                      this.props.navigator.navigate("AreaStates", {
                        areaId,
                        uId,
                        areaName,
                        areaUId,
                      });
                    }}
                  >
                    <RenderMenuItem>
                      {translate("area.DefinedStates")}
                    </RenderMenuItem>
                  </MenuItem>
                  {/* === Area Users === */}
                  <MenuItem
                    onPress={() => {
                      this.hideMenu();
                      let { areaId, areaName, areaUId } = this.props.model;
                      this.props.navigator.navigate("AreaUsers", {
                        areaId,
                        areaUId,
                        areaName,
                      });
                    }}
                  >
                    <RenderMenuItem>
                      {translate("area.areaUsers")}
                    </RenderMenuItem>
                  </MenuItem>
                  <MenuDivider />
                  {/* === Remove Area === */}
                  <MenuItem
                    onPress={() => {
                      this.hideMenu();
                      let { areaId, areaUId } = this.props.model;
                      this.props.navigator.navigate("AreaRemove", {
                        areaId,
                        areaUId,
                      });
                    }}
                  >
                    <RenderMenuItem>
                      {translate("navigation.AreaRemove")}
                    </RenderMenuItem>
                  </MenuItem>
                </Menu>
              )}
            </View>
          )}
          <Box flex="1">
            <TouchableHighlight
              underlayColor="transparent"
              style={{
                flex: 1,
              }}
              onPress={() => this.NavigateEditForm()}
            >
              <HStack
                justifyContent="space-between"
                alignItems="center"
                flex={1}
              >
                {/* === Area  === */}
                <Text style={{ fontSize: 16, fontWeight: "bold" }}>
                  {model.areaName || translate("app.noName")}
                </Text>
                {/* === edit Icon === */}
                <IconButton
                  colorScheme="muted"
                  variant="ghost"
                  onPress={() => this.NavigateEditForm()}
                  icon={
                    <FontAwesomeIcon
                      icon={faEdit}
                      size={16}
                      color={Theme.COLORS.MUTED}
                    />
                  }
                />
              </HStack>
            </TouchableHighlight>
            {/* === Sub Area === */}
            {(model.accessLevel === "Admin" ||
              model.accessLevel === "Support" ||
              model.subAreas.length !== 0) && (
              <HStack
                space="3"
                style={{
                  marginTop: 10,
                  paddingTop: 15,
                  borderTopColor: Theme.COLORS.MUTED,
                  borderTopWidth: 1,
                }}
              >
                {(model.accessLevel === "Admin" ||
                  model.accessLevel === "Support") && (
                  <ArButton
                    color="primary"
                    style={{ flex: 1, marginBottom: 0, height: 40 }}
                    onPress={() => this.handleOnAddPress()}
                    icon={faPlus}
                  >
                    {translate("area.createNewSubArea")}
                  </ArButton>
                )}
                {model.subAreas.length !== 0 && (
                  <ArButton
                    icon={
                      this.state.isSubAreasOpened ? faChevronUp : faChevronDown
                    }
                    variant="outline"
                    iconColor={Theme.COLORS.PRIMARY}
                    onPress={() => this.toggleSubAreas()}
                    style={{ flex: 1, marginBottom: 0, height: 40 }}
                  >
                    {translate("area.showSubArea", {
                      NOsubArea: (model.subAreas || []).length,
                    })}
                  </ArButton>
                )}
              </HStack>
            )}
            {this.state.isSubAreasOpened && (
              <Box>
                {(model.subAreas || []).map((s) => (
                  <AreaListItem
                    key={s.areaId || s.areaUId}
                    variation={model.parentAreaId ? "sm" : "md"}
                    model={s}
                    allAreas={this.props.allAreas}
                    navigator={this.props.navigator}
                  >
                    {s.areaName}
                  </AreaListItem>
                ))}
              </Box>
            )}
          </Box>
        </HStack>
      </Box>
    );
  }
}
const RenderMenuItem = ({ children }) => {
  if (Platform.OS === "web") {
    return (
      <View style={{ width: "100%" }}>
        <Text style={style.menuTextStyle}>{children}</Text>
      </View>
    );
  }
  return <Text style={style.menuTextStyle}>{children}</Text>;
};
const style = StyleSheet.create({
  wrapper: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Theme.COLORS.BLOCK,

    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.4,
    shadowRadius: 10,
    elevation: 4,
  },
  menuTextStyle: {
    textAlign: "right",
    fontSize: 12,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(AreaListItem);
